import { createSvgIcon } from '@material-ui/core';

export const Cue2Icon = createSvgIcon(
  <svg
    viewBox="0 0 48 48"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 36.1667L4 24.5L16 12.8333L18.85 15.6042L9.65 24.5486L18.8 33.4444L16 36.1667ZM32 36.1667L29.15 33.3958L38.35 24.4514L29.2 15.5556L32 12.8333L44 24.5L32 36.1667Z"
      fill="currentColor"
    />
  </svg>,
  'Cue2Icon',
);
